export const STATUS_ELEMENT_ADDITIONAL_INFO_REQUIRED = 'ADDITIONAL_INFO_REQUIRED';
export const STATUS_ELEMENT_APPROVED = 'APPROVED';
export const STATUS_ELEMENT_REJECTED = 'REJECTED';
export const STATUS_ELEMENT_PENDING = 'PENDING';
